import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import "./index.css";
import App from "./App";

posthog.init("phc_viPFVcNuXEewJDrzLKrpUY7XzSFBVMMSE6rXGzVHUL7S", {
  api_host: "https://us.i.posthog.com",
  defaults: "2026-01-30",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
